import {
  getRfSubscriptionAgreement,
  hasRemainingDownloads,
} from '../../../rfSubscriptionPredicates';
import type { BannerRule } from '../types';

export const ENTERPRISE_CONTACT_SALES_FORM_ID = '701Pm00001Swdq0IAB';
export const ENTERPRISE_CONTACT_SALES_FORM_SOURCE =
  'GI_Site_EnterpriseService ';

const zeroDownloadsRule: BannerRule = (
  { downloadAgreements, isRfRedownloadable, siteMap },
  t
) => {
  if (isRfRedownloadable) return null;

  const rfAgreement = getRfSubscriptionAgreement(downloadAgreements);
  if (!rfAgreement || !rfAgreement.agreementDetails) return null;
  if (hasRemainingDownloads(rfAgreement)) return null;

  return {
    severity: 'warning',
    heading: t('downloads_remaining_monthly_count', { count: 0 }),
    description: t('need_more_monthly_downloads_contact_us', {
      links: [
        {
          href: siteMap.enterpriseContactSalesForm(
            ENTERPRISE_CONTACT_SALES_FORM_ID,
            ENTERPRISE_CONTACT_SALES_FORM_SOURCE
          ),
        },
      ],
    }),
    rawHtml: true,
  };
};

export default zeroDownloadsRule;
